import { useFileDelete } from "@bundles/vefiles/hooks"
import { Box, Button, ConfirmationDialog, Icon, Paper, Stack, styled, Typography } from "@tm/components"
import { ERIKContentService } from "@tm/data"
import { useLocalization } from "@tm/localization"
import { useState } from "react"
import { FileSharePopUp } from "../shared"

const StyledPaper = styled(Paper)({
    position: "absolute",
    marginLeft: "65%",
    width: "fit-content",
    top: "1em",
    zIndex: "100",
    padding: 0,
    display: "flex",
    justifyContent: "space-between",
    borderRadius: "5px",
})

const CloseButton = styled(Box)(({ theme }) => {
    return {
        width: "5em",
        border: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "0 5px 5px 0",
        transition: "fill 0.3s ease",
        backgroundColor: theme.palette.grey[500],
        "&:hover": {
            backgroundColor: theme.palette.grey[700],
            "& svg.MuiSvgIcon-root.icon-cancel-x": {
                fill: theme.palette.grey[50],
            },
        },
    }
})

const StyledStack = styled(Stack)(({ theme }) => {
    return {
        display: "flex",
        padding: "5px 12px",
        alignItems: "center",
        border: "1px solid transparent",
        borderRadius: "5px 0 0 5px",
        "&:hover": {
            border: `1px solid ${theme.colors?.primary}`,
        },
    }
})

type FileItemSelectionProps = {
    allSelected: boolean
    selectedFiles: ERIKContentService.FileMeta[]
    selectDeselectAllFiles: (isSelect: boolean) => void
}

export function FileItemSelection({ allSelected, selectedFiles, selectDeselectAllFiles }: FileItemSelectionProps) {
    const { translateText } = useLocalization()
    const { deleteFile } = useFileDelete()
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false)

    const handleBulkDelete = () => {
        const ids = selectedFiles.map((file) => file.id)
        deleteFile(ids)
        selectDeselectAllFiles(false)
    }

    return (
        <>
            <StyledPaper elevation={3}>
                <StyledStack direction="row" spacing={1.5}>
                    <Typography variant="label" textTransform="uppercase" color="GrayText">
                        {translateText(701)}
                    </Typography>
                    <Typography>
                        {selectedFiles.length} {translateText(479)}
                    </Typography>
                    <Button onClick={() => selectDeselectAllFiles(!allSelected)}>{allSelected ? translateText(703) : translateText(702)}</Button>
                    {/* <Button startIcon={<Icon name="download" />} onClick={() => {}} /> */}
                    <FileSharePopUp selectedFiles={selectedFiles} />
                    <Button startIcon={<Icon name="delete" />} onClick={() => setDeleteDialogOpen(true)} />
                </StyledStack>
                <CloseButton onClick={() => selectDeselectAllFiles(false)}>
                    <span>
                        <Icon size="small" name="cancel-x" />
                    </span>
                </CloseButton>
            </StyledPaper>
            <ConfirmationDialog
                open={deleteDialogOpen}
                confirmationButtonText={translateText(585)}
                cancelButtonText={translateText(584)}
                onOutsideClick={() => setDeleteDialogOpen(false)}
                onConfirm={() => handleBulkDelete()}
                onCancel={() => setDeleteDialogOpen(false)}
            >
                {translateText(translateText(835))}
            </ConfirmationDialog>
        </>
    )
}
